import { Box } from '@mui/material';

const BANDS = (() => {
  const heights = [320, 215, 160, 130, 100, 60];
  const colors = [
    '#00697a',
    '#0a8ea0',
    '#1abed5',
    '#0fc9e2',
    '#5fd9ea',
    '#a0ecf5',
  ];
  return heights.map((height, i) => ({
    height: `${height}px`,
    o: 0.22,
    color: colors[i],
  }));
})();

export const SchemeBands = () => (
  <Box sx={{
    position: 'absolute',
    inset: 0,
    overflow: 'hidden',
    pointerEvents: 'none',
    zIndex: 0,
    mixBlendMode: 'screen',
  }}>
    {BANDS.map((b, i) => (
      <Box
        key={i}
        sx={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          width: '100%',
          height: b.height,
          background: b.color,
          opacity: b.o,
          mixBlendMode: 'screen',
        }}
      />
    ))}
  </Box>
);

export default SchemeBands;
